<script>
export default {
    props: {
        // Type de device
        device: {
            type: String,
            required: true
        },
        // Id du rayon
        shelfId: {
            type: String,
            required: true
        },
        // Label du rayon
        label: {
            type: String,
            required: true
        },
        // Checkbox "Afficher tout"
        showAllCheckBox: {
            type: Object,
            required: true
        },
        // Checkboxes des catégories et sous-catégories
        checkBoxes: {
            type: Array,
            required: true
        },
        //Indique si on affiche le rayon ou non
        show: {
            type: Boolean,
            required: true
        },
        // Indique si il y a plusieurs rayons
        isMultiShelf: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isDesktop: function isDesktop() {
            return window.matchMedia(this.mediaQuery).matches
        },
        mediaQuery: function mediaQuery() {
            return "(min-width: " + myshop.ob1.breakpoints.lg + "px)"
        },
        selectedCategoriesAreAllChecked: function () {
            return this.checkBoxes.filter(category => category.isChecked === false).length === 0
        },
        areThereSelectedCategories: function () {
            return this.checkBoxes.filter(category => category.isChecked).length > 0
        },
        areThereIndeterminatedCategories: function () {
            return this.checkBoxes.filter(category => category.isIndeterminated).length > 0
        }
    },
    methods: {
        showAllHandler: function (emitEvent) {
            this.showAllCheckBox.isIndeterminated = false
            const isShowAllElementChecked = this.showAllCheckBox.isChecked

            // Mise à jour des checkboxs relatives aux catégories et sous-catégories
            for (const category of this.checkBoxes) {
                this.toggleCheckbox(category, isShowAllElementChecked, false)
                for (const subCategory of category.subCategoriesCheckBoxes) {
                    this.toggleCheckbox(subCategory, isShowAllElementChecked, false)
                }
            }
            if (emitEvent) {
                this.changeCheckBoxes()
            }
        },
        categoryHandler: function (seoId, emitEvent) {
            const currentCategory = this.checkBoxes.find(category => category.seoId === seoId)

            // Si on clique sur la case à cocher alors qu'on est dans un état indéterminé on coche la case
            if (currentCategory.isIndeterminated) {
                this.toggleCheckbox(currentCategory, true, false)
            }
            /* ---------------- Gestion des sous catégories ---------------- */
            const isCurrentCategoryChecked = currentCategory.isChecked
            // Mise à jour des checkboxs relatives aux sous-catégories
            for (const subCategory of currentCategory.subCategoriesCheckBoxes) {
                subCategory.isChecked = isCurrentCategoryChecked
            }

            /* ---------------- Gestion de la case à cocher "Afficher tout" ---------------- */
            // Si toutes les catégories sont maintenant cochéees (cas où on vient de cocher la dernière catégorie
            // encore non cochée)
            if (this.selectedCategoriesAreAllChecked) {
                this.toggleCheckbox(this.showAllCheckBox, true, false)
            } else {
                // Si au moins une catégorie est cochée mais pas toutes, on met la checkbox en état indéterminé
                if (this.areThereSelectedCategories) {
                    this.toggleCheckbox(this.showAllCheckBox, false, true)
                } else {
                    // Sinon on est en train de décocher la dernière catégorie encore cochée : on supprime alors l'état
                    // indéterminé
                    this.showAllCheckBox.isIndeterminated = false
                }
            }
            if (emitEvent) {
                this.changeCheckBoxes()
            }
        },
        subCategoryHandler: function (seoId, emitEvent) {
            /* ---------------- Gestion de la catégorie parente et de la case "Afficher tout" ---------------- */
            const parentSubCategory = this.checkBoxes.find(category => category.subCategoriesCheckBoxes.find(subCategory => subCategory.seoId === seoId))
            const allSubCategoriesAreChecked = parentSubCategory.subCategoriesCheckBoxes.filter(subCategory => subCategory.isChecked === false).length === 0
            const areThereSelectedSubCategories = parentSubCategory.subCategoriesCheckBoxes.filter(subCategory => subCategory.isChecked).length > 0

            // Si toutes les sous catégories sont cochées => on coche la catégorie parente
            if (allSubCategoriesAreChecked) {
                this.toggleCheckbox(parentSubCategory, true, false)
                // Si seulement une partie de toutes les catégories / sous catégories sont cochées, on met la case
                // "Afficher tout" en état indéterminé
                this.checkIfSomeCategoriesAreSelected()
            } else {
                // Si au moins une sous-catégorie est cochée mais pas toutes, on met la checkbox du parent en état
                // indéterminé
                if (areThereSelectedSubCategories) {
                    this.toggleCheckbox(parentSubCategory, false, true)
                    this.toggleCheckbox(this.showAllCheckBox, false, true)
                } else {
                    // Sinon on est en train de décocher la dernière sous catégorie encore cochée : on supprime alors
                    // l'état indéterminé du parent
                    parentSubCategory.isIndeterminated = false

                    // Si il y a au moins une catégorie sélectionnée ou indéterminée on coche la case "Afficher tout"
                    this.checkIfSelectedOrUndeterminated()
                }
            }
            if (emitEvent) {
                this.changeCheckBoxes()
            }
        },
        changeCheckBoxes: function () {
            this.$emit('change-check-boxes', {shelfId: this.shelfId, checkBoxes: this.checkBoxes})
        },
        checkBoxesReinitialisation: function () {
            this.checkBoxes.forEach(category => {
                this.toggleCheckbox(category, false, false)
                if (category.subCategoriesCheckBoxes.length > 0) {
                    category.subCategoriesCheckBoxes.forEach(subCategory => {
                        this.toggleCheckbox(subCategory, false, false)
                    })
                }
            })
            this.toggleCheckbox(this.showAllCheckBox, false, false)
        },
        toggleCheckbox: function (checkboxToToggle, isCheckedBool, isIndeterminatedBool) {
            checkboxToToggle.isChecked = isCheckedBool;
            checkboxToToggle.isIndeterminated = isIndeterminatedBool
        },
        checkIfSomeCategoriesAreSelected: function () {
            if ((this.areThereIndeterminatedCategories || this.areThereSelectedCategories) && !this.selectedCategoriesAreAllChecked) {
                this.toggleCheckbox(this.showAllCheckBox, false, true)
            } else if (this.selectedCategoriesAreAllChecked) {
                this.toggleCheckbox(this.showAllCheckBox, true, false)
            }
        },
        checkIfSelectedOrUndeterminated: function () {
            if (this.areThereIndeterminatedCategories || (this.areThereSelectedCategories && !this.selectedCategoriesAreAllChecked)) {
                this.toggleCheckbox(this.showAllCheckBox, false, true)
            } else {
                this.toggleCheckbox(this.showAllCheckBox, false, false)
            }
        }
    }
}
</script>

<template>
    <div>
        <ob1-expanding-accordion-card
            v-if="show"
            :link-id="'link-' + shelfId"
            :collapsed-block-id="'collapsed-block-' + shelfId"
            :link-title="label"
            :is-showed="isDesktop"
            :is-multi-card="isMultiShelf"
        >
            <ul class="items-list">
                <li class="mb-1">
                    <ob1-check-box2
                        :id="showAllCheckBox.checkBoxId"
                        v-model="showAllCheckBox.isChecked"
                        class="items-list-item"
                        :name="showAllCheckBox.checkBoxId"
                        :label="showAllCheckBox.label"
                        :is-indeterminated="showAllCheckBox.isIndeterminated"
                        @change="showAllHandler(true)"
                    />
                </li>
                <li v-for="category in checkBoxes" :key="category.checkBoxId" class="ms-1">
                    <ob1-check-box2
                        :id="device + '-' + category.checkBoxId"
                        v-model="category.isChecked"
                        class="items-list-item"
                        :name="device + '-' + category.checkBoxId"
                        :label="category.label + ' (' + category.accessoriesCount + ')'"
                        :is-indeterminated="category.isIndeterminated"
                        :is-disabled="category.accessoriesCount === 0"
                        @change="categoryHandler(category.seoId, true)"
                    />
                    <ul class="items-list">
                        <li v-for="subCategory in category.subCategoriesCheckBoxes" :key="subCategory.checkBoxId" class="ms-1 my-1">
                            <ob1-check-box2
                                :id="device + '-' + subCategory.checkBoxId"
                                v-model="subCategory.isChecked"
                                class="items-list-item"
                                :name="device + '-' + subCategory.checkBoxId"
                                :label="subCategory.label + ' (' + subCategory.accessoriesCount + ')'"
                                :is-indeterminated="subCategory.isIndeterminated"
                                :is-disabled="subCategory.accessoriesCount === 0"
                                @change="subCategoryHandler(subCategory.seoId, true)"
                            />
                        </li>
                    </ul>
                </li>
            </ul>
        </ob1-expanding-accordion-card>
    </div>
</template>
<style scoped lang="scss">
@import 'ob1_common', 'ob1_variables', 'msh_mixins';

.accordion
{
    .card.card-expanded.multi:last-child {
        border-color: #ccc;
    }
}

</style>
